import type { DeepPartial } from '@luna/utils-ts';

import type { Statements } from '../../types/Statements';

export const statementsROFeatureConfig: DeepPartial<Statements> = {
    hasPaging: true,
    sendStatementIdAsQueryParam: true,
    showCoreStatements: true,
};
